import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const ContactFilters = ({ 
  searchTerm, 
  onSearchChange, 
  filters, 
  onFilterChange, 
  onClearFilters,
  onImportContacts,
  onExportContacts 
}) => {
  const genreOptions = [
    { value: '', label: 'All Genres' },
    { value: 'fiction', label: 'Fiction' },
    { value: 'non-fiction', label: 'Non-Fiction' },
    { value: 'mystery', label: 'Mystery/Thriller' },
    { value: 'romance', label: 'Romance' },
    { value: 'sci-fi', label: 'Science Fiction' },
    { value: 'fantasy', label: 'Fantasy' },
    { value: 'biography', label: 'Biography' },
    { value: 'business', label: 'Business' },
    { value: 'health', label: 'Health & Wellness' },
    { value: 'technology', label: 'Technology' }
  ];

  const outletTypeOptions = [
    { value: '', label: 'All Outlet Types' },
    { value: 'newspaper', label: 'Newspaper' },
    { value: 'magazine', label: 'Magazine' },
    { value: 'online', label: 'Online Publication' },
    { value: 'blog', label: 'Blog' },
    { value: 'podcast', label: 'Podcast' },
    { value: 'tv', label: 'Television' },
    { value: 'radio', label: 'Radio' },
    { value: 'newsletter', label: 'Newsletter' }
  ];

  const locationOptions = [
    { value: '', label: 'All Locations' },
    { value: 'new-york', label: 'New York' },
    { value: 'los-angeles', label: 'Los Angeles' },
    { value: 'chicago', label: 'Chicago' },
    { value: 'san-francisco', label: 'San Francisco' },
    { value: 'boston', label: 'Boston' },
    { value: 'washington-dc', label: 'Washington DC' },
    { value: 'atlanta', label: 'Atlanta' },
    { value: 'national', label: 'National' },
    { value: 'international', label: 'International' }
  ];

  const engagementOptions = [
    { value: '', label: 'All Engagement Levels' },
    { value: 'high', label: 'High Engagement' },
    { value: 'medium', label: 'Medium Engagement' },
    { value: 'low', label: 'Low Engagement' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'pending', label: 'Pending' }
  ];

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      {/* Search and Quick Actions */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search contacts by name, outlet, or email..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        
        <div className="flex items-center space-x-3">
          <Button
            variant="outline"
            onClick={onImportContacts}
            iconName="Upload"
            iconPosition="left"
          >
            Import
          </Button>
          <Button
            variant="outline"
            onClick={onExportContacts}
            iconName="Download"
            iconPosition="left"
          >
            Export
          </Button>
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <Select
          label="Genre Specialization"
          options={genreOptions}
          value={filters?.genre}
          onChange={(value) => onFilterChange('genre', value)}
          placeholder="Select genre"
        />

        <Select
          label="Outlet Type"
          options={outletTypeOptions}
          value={filters?.outletType}
          onChange={(value) => onFilterChange('outletType', value)}
          placeholder="Select outlet type"
        />

        <Select
          label="Location"
          options={locationOptions}
          value={filters?.location}
          onChange={(value) => onFilterChange('location', value)}
          placeholder="Select location"
        />

        <Select
          label="Engagement Level"
          options={engagementOptions}
          value={filters?.engagement}
          onChange={(value) => onFilterChange('engagement', value)}
          placeholder="Select engagement"
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Select status"
        />
      </div>
      {/* Clear Filters */}
      {hasActiveFilters && (
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Filter" size={16} />
            <span>Filters applied</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear all filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContactFilters;